import { getEnvVar } from '@rea-argonaut/env';

export const getEnv = {
  GOOGLE_PLACES_API_URL: () => getEnvVar<string>('googlePlacesApiUrl') || '',
  GOOGLE_PLACES_API_KEY: () => getEnvVar<string>('googlePlacesApiKey') || '',
  GOOGLE_MAPS_API_KEY: () => getEnvVar<string>('googleMapsApiKey') || '',
  CANONICAL_DOMAIN: () => getEnvVar<string>('canonicalDomain') || '',
  PUBLIC_EXPERIENCE_API_URL: () => getEnvVar<string>('publicExperienceApiUrl') || '',
  INTERNAL_EXPERIENCE_API_URL: () => getEnvVar<string>('internalExperienceApiUrl') || '',
  CONNECTION_API_URL: () => getEnvVar<string>('connectionApiUrl') || '',
};
